import type { User, UserDTO } from '../model/types'

export const mapUserFromDTO = ({
    id,
    first_name,
    last_name,
    username,
    photo_url,
    is_anonymous,
    partner_id
}: UserDTO): User => ({
    id,
    firstName: first_name,
    lastName: last_name,
    username: username,
    photoUrl: photo_url,
    isAnonymous: is_anonymous,
    partnerId: partner_id
})
